import MenuCategorySliceType from './MenuCategorySliceType';

const MenuCategoryInitialState: MenuCategorySliceType = {
  loading: false,
  data: [],
};

export default MenuCategoryInitialState;
